await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-js-components-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export {default as activePageReducer} from './activePageReducer.es';
export {default as dataLayoutReducer} from './dataLayoutReducer.es';
export {default as dragAndDropReducer} from './dragAndDropReducer.es';
export {default as fieldEditableReducer} from './fieldEditableReducer.es';
export {default as fieldReducer} from './fieldReducer.es';
export {default as historyReducer} from './historyReducer.es';
export {default as languageReducer} from './languageReducer.es';
export {default as pageValidationReducer} from './pageValidationReducer.es';
export {default as pagesStructureReducer} from './pagesStructureReducer.es';
